import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthFacadeService } from 'ngpd-merceros-authentication-fe-components';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthService {
  public mssoAuthService: AuthFacadeService;

  private readonly _routeURL = environment.API_URL;

  constructor(private readonly _http: HttpClient, private readonly _authFacadeService: AuthFacadeService) {
    this.mssoAuthService = _authFacadeService;
  }

  /* returns if user is logged in */
  public get mssoLoggedIn$(): Observable<boolean> {
    return this.mssoAuthService.loggedIn$;
  }

  /* returns if user has been mfa authenticated */
  public get mfaAuthenticated$(): Observable<boolean> {
    return this.mssoAuthService.mfaAuthenticated$;
  }

  /* returns if user has been logged in and mfa authenticated */
  public get fullyAuthenticated$(): Observable<boolean> {
    return this.mssoAuthService.fullyAuthenticated$;
  }

  /* returns an array for logged in and mfa authenticated checks */
  // public get seperateAuths$(): Observable<boolean> {
  //   return this.mssoAuthService.seperateAuths$;
  // }


  public recreateToken(): Observable<any> {
    return this._http.get(this._routeURL + '/user/recreate-token', { withCredentials: true });
  }

  private closeAllOpenOverlays(): void {
    if (typeof document === 'undefined') {
      return;
    }

    const overlayContainers = document.querySelectorAll('.cdk-overlay-container');
    overlayContainers.forEach((container: Element) => {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    });

    document.body.classList.remove('cdk-global-scrollblock');
    document.body.style.removeProperty('overflow');
  }

  public logout(): void {
    this.closeAllOpenOverlays();

    // this.mssoAuthService.logout();
    if (!!+environment.devLoginEnabled) {
      this.mssoAuthService.logout();
    } else {
      this.mssoAuthService.singleLogout();
    }
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
  }
}
